import Card from "@/components/Common/Card";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import EstimateTabs from "./table/EstimateTabs";
import { ItemSheetLatest, ItemSheetOriginal } from "@/types/itemsheet";
import EstimateTitle from "./table/EstimateTitle";
import EstimateFilters from "./table/EstimateFilters";
import EstimateProductTable from "./table/EstimateProductTable";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDownloadProjectGroupsItemSheet } from "@/libs/react-query/hooks/useItemsheetsQuery";
import { useSelectedProjectInfo } from "../hooks/useTabStore";
import { useTableStore, useFilteredRows } from "../hooks/useTableStore";

interface Props {
  tab: string;
  setTab: (tab: string) => void;
  latests: ItemSheetLatest[];
  latestsSheetData: ItemSheetLatest | undefined;
  selectedOriginal: ItemSheetOriginal;
}

export function EstimateTabsView({
  tab,
  setTab,
  latests,
  latestsSheetData,
  selectedOriginal,
}: Props) {
  const { group_id = "" } = useParams();
  const [rowSelection, setRowSelection] = useState<Record<number, boolean>>({});

  const estimateInfo = useSelectedProjectInfo();
  const filteredRows = useFilteredRows();
  const setIsExcelDownloading = useTableStore(
    (state) => state.setIsExcelDownloading
  );

  const { mutateAsync: downloadExcel } = useDownloadProjectGroupsItemSheet(
    group_id,
    latestsSheetData?.id || ""
  );

  const handleExcelDownload = async () => {
    if (!group_id || !estimateInfo || !rowSelection) return;

    const selectedRows = Object.keys(rowSelection).filter(
      (key) => rowSelection[Number(key)]
    );

    if (selectedRows.length === 0) return;

    // 선택된 행들의 실제 seq_no 값을 가져옴
    const selectedSeqNums = selectedRows.map((rowIndexStr) => {
      const rowIndex = Number(rowIndexStr);
      const row = filteredRows[rowIndex];
      // seq_no가 null이면 기본값으로 rowIndex + 1 사용, 아니면 seq_no 그대로
      return row?.seq_no != null ? row.seq_no : rowIndex + 1;
    });

    const { file } = await downloadExcel({
      project_id: estimateInfo.projectId,
      project_type: estimateInfo.projectType,
      original_id: estimateInfo.originalId,
      list_nums: selectedSeqNums,
    });

    const url = URL.createObjectURL(file);

    const link = document.createElement("a");
    link.href = url;

    link.download = `${latestsSheetData?.title}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);

    setIsExcelDownloading(false);
  };

  return (
    <div className="mt-5">
      <Card noTitle noBorder>
        <Tabs value={tab} onValueChange={setTab} className="flex-1">
          <EstimateTabs
            latests={latests}
            handleExcelDownload={handleExcelDownload}
          />
          <div className="p-5">
            {latests.map((item) => (
              <TabsContent key={item.id} value={item.id}>
                <div className="flex flex-col gap-[10px]">
                  <EstimateTitle defaultTitle={item.title} />
                  <EstimateFilters latestsSheetData={latestsSheetData?.data} />
                  <EstimateProductTable
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    selectedOriginal={selectedOriginal}
                  />
                </div>
              </TabsContent>
            ))}
          </div>
        </Tabs>
      </Card>
    </div>
  );
}
